var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightRay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 144.5 533.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient);\n        isolation: isolate;\n        opacity: .5;\n      }\n\n      .st1 {\n        fill: #4896a0;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 72.1,
    y1: -207.9,
    x2: 72.2,
    y2: 138.9,
    gradientTransform: "translate(0 184) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f2",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lightrays"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "60.8 533.1 0 .2 144.5 0 60.8 533.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "weight"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 95.4,
    y: 1046.7,
    width: 5,
    height: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRay);
export default __webpack_public_path__ + "static/media/light-ray.b76484e21170741cc71552936c18994c.svg";
export { ForwardRef as ReactComponent };